import { PRFilterState, PRListType, PRUserFilterType } from './types';

// Constant for the default filter preferences for both the repository
// and workspace pull request lists
export const DEFAULT_PR_FILTER_PREFERENCES: Record<
  PRListType,
  {
    prState: PRFilterState[];
    userFilter: PRUserFilterType;
  }
> = {
  [PRListType.Repository]: {
    prState: ['OPEN', 'DRAFT'],
    userFilter: 'ALL',
  },
  [PRListType.Workspace]: {
    prState: ['OPEN', 'DRAFT'],
    userFilter: 'REVIEWING',
  },
};
